import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import transform from 'lodash/transform';

type NoUndefinedField<T> = { [P in keyof T]-?: NoUndefinedField<NonNullable<T[P]>> };

export function cleanEmpty<T extends Record<string, any>>(
  collection: T,
  isSkipBoolean = true,
): NoUndefinedField<T> {
  const add = isArray(collection)
    ? (collection: any, key: any, value: any) => collection.push(value)
    : (collection: any, key: any, value: any) => (collection[key] = value);

  return transform(collection, (collection, value, key) => {
    if (isObject(value)) {
      // eslint-disable-next-line no-param-reassign
      value = cleanEmpty(value);
      if (isEmpty(value)) {
        return;
      }
    } else {
      if (!value && (typeof value !== 'boolean' || (typeof value === 'boolean' && isSkipBoolean))) {
        return;
      }
    }
    add(collection, key, value);
  });
}
